import { faFileUpload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { memo, useCallback, type ChangeEvent, type DragEvent } from 'react'
import { useTheme } from '../../../../theme/hooks'

type Props = {
  fileName: string
  accept: string
  onFileSelect: (file: File) => void
}

const FILE_INPUT_ID = 'fileInput'

const FileDropzoneBase = ({ fileName, accept, onFileSelect }: Props) => {
  const { theme } = useTheme()

  const handleDrop = useCallback(
    (event: DragEvent<HTMLDivElement>) => {
      event.preventDefault()
      const file = event.dataTransfer.files[0]
      if (file) onFileSelect(file)
    },
    [onFileSelect],
  )

  const handleInputChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0]
      if (file) onFileSelect(file)
    },
    [onFileSelect],
  )

  const openPicker = useCallback(() => {
    document.getElementById(FILE_INPUT_ID)?.click()
  }, [])

  return (
    <div className="mt-4 space-y-4">
      <label
        className="text-sm font-medium"
        style={{ color: theme.text.primary }}
      >
        Fichier LiDAR
      </label>
      <div
        className="rounded-lg border-2 border-dashed p-8 text-center transition-colors"
        id="dropArea"
        style={{
          borderColor: theme.input.border,
          cursor: 'pointer',
          backgroundColor: theme.input.bg,
        }}
        onDrop={handleDrop}
        onDragOver={e => e.preventDefault()}
        onClick={openPicker}
        onMouseEnter={e => {
          e.currentTarget.style.borderColor = theme.border.focus
          e.currentTarget.style.backgroundColor = theme.input.bgHover
        }}
        onMouseLeave={e => {
          e.currentTarget.style.borderColor = theme.input.border
          e.currentTarget.style.backgroundColor = theme.input.bg
        }}
      >
        {fileName ? (
          <div className="space-y-2">
            <FontAwesomeIcon
              icon={faFileUpload}
              className="mx-auto h-8 w-8"
              style={{ color: theme.status.success.icon }}
            />
            <p
              className="text-sm font-medium"
              style={{ color: theme.text.primary }}
            >
              {fileName}
            </p>
          </div>
        ) : (
          <div className="space-y-2">
            <FontAwesomeIcon
              icon={faFileUpload}
              className="mx-auto h-8 w-8"
              style={{ color: theme.text.tertiary }}
            />
            <p
              className="text-sm font-medium"
              style={{ color: theme.text.primary }}
            >
              Glissez et déposez votre fichier ici
            </p>
            <p className="text-xs" style={{ color: theme.text.secondary }}>
              ou cliquez pour sélectionner un fichier
            </p>
          </div>
        )}
      </div>
      <input
        type="file"
        name="url"
        className="hidden"
        accept={accept}
        onChange={handleInputChange}
        id={FILE_INPUT_ID}
      />
    </div>
  )
}

export const FileDropzone = memo(FileDropzoneBase)
